import { render } from "./ProjectParameters.vue?vue&type=template&id=5a06d26e&lang=true"
import script from "./ProjectParameters.vue?vue&type=script&lang=js"
export * from "./ProjectParameters.vue?vue&type=script&lang=js"

import "./ProjectParameters.vue?vue&type=style&index=0&id=5a06d26e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__